import { Button } from "@mui/joy";
import { useEffect, useState } from "react";
import { PlanKey, planKeyToName } from "components/task/payment/planTypes";
import {
  loadTossPayments,
  TossPaymentsPayment,
} from "@tosspayments/tosspayments-sdk";
import { v4 as uuidv4 } from "uuid";
import { trackCapiStandardEvent } from "analytics/metaCapi";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import { useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";
import { PATH } from "routes/paths";
import useAutoLoginV3 from "./useAutoLoginV3";

export default function PaymentButtonV3({
  selectedPlan,
}: {
  selectedPlan: PlanKey;
}) {
  const tossPaymentsClientKey = process.env.REACT_APP_TOSSPAYMENTS_CLIENT_KEY!!;

  const user = useRecoilValue(userSimpleAtom);
  const { isChecking } = useAutoLoginV3();
  const navigate = useNavigate();
  const [tossPaymentsPayment, setTossPaymentsPayment] =
    useState<TossPaymentsPayment | null>();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const buttonText = "결제하기";

  async function requestTossPayments() {
    if (tossPaymentsPayment) {
      try {
        await tossPaymentsPayment?.requestPayment({
          method: "CARD",
          amount: {
            currency: "KRW",
            value:
              selectedPlan === "starter"
                ? 295000
                : selectedPlan === "challenger"
                  ? 395000
                  : 465000,
          },
          orderId: uuidv4(),
          orderName: `디스턴싱 ${planKeyToName[selectedPlan]} 플랜 / 100일`,
          customerEmail: user?.email || "",
          customerName: user?.nickname,
          successUrl: window.location.origin + PATH.v3TosspaymentsSuccess,
          failUrl: window.location.origin + PATH.v3Payment,
          card: {
            useEscrow: false,
            flowMode: "DEFAULT",
            useCardPoint: false,
            useAppCardOnly: false,
          },
        });
      } catch (error) {
        // 에러 처리하기
        console.error(error);
      }
    }
  }

  useEffect(() => {
    async function fetchTossPaymentsPayment() {
      if (tossPaymentsClientKey) {
        const tossPayments = await loadTossPayments(tossPaymentsClientKey);
        const payment = tossPayments.payment({
          customerKey: `ck_${uuidv4()}`,
        });

        setTossPaymentsPayment(payment);
      }
    }

    fetchTossPaymentsPayment();
  }, [tossPaymentsClientKey]);

  // 로그인 체크 후 리다이렉트
  useEffect(() => {
    if (!isChecking && !user?.accessToken) {
      navigate(PATH.v3Login, { replace: true });
    }
  }, [isChecking, user, navigate]);

  const handlePaymentRequest = () => {
    trackCapiStandardEvent(
      "InitiateCheckout",
      {
        value: 59000,
        currency: "KRW",
        externalId: user?.userId,
        email: user?.email,
      },
      undefined,
      "v3"
    );

    requestTossPayments();
  };

  return (
    <>
      <Button
        loading={isLoading || isChecking}
        disabled={
          isChecking || !user?.accessToken || user?.isSubscribing === true
        }
        onClick={() => {
          handlePaymentRequest();
        }}
        size={"lg"}
        color={"primary"}
        sx={{
          width: "100%",
          fontWeight: 700,
        }}
      >
        {buttonText}
      </Button>
    </>
  );
}
